import { useState } from 'react'

export const useTopElement = (): [boolean, (id: string) => void] => {
    const [isTop, handleSetIsTop] = useState<boolean>(true)

    function setIsTop(id: string) {
        const elem1 = document.getElementById(id)?.getBoundingClientRect();
        const parentBounds = document.getElementById("mainCanvas")?.getBoundingClientRect();
        let isTop = true;
        if (elem1 && parentBounds) {
            isTop = elem1.top > parentBounds?.top + 50
        }
        handleSetIsTop(isTop);
    }

    return [isTop, setIsTop]
}
